// API helpers
import { API_BASE_URL } from '../config/environment';
const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || null;
const RECAPTCHA_ENABLED = process.env.REACT_APP_RECAPTCHA_ENABLED === 'true';
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || null;

export async function fetchEvents(filters = {}) {
  const { location = 'all', type = 'all', month = 'current' } = filters;
  const params = new URLSearchParams({ location, type, month });
  const response = await fetch(`${API_BASE_URL}/api/events?${params}`);
  if (!response.ok) throw new Error('Failed to fetch events');
  return response.json();
}

export async function fetchEventBySlug(slug) {
  const response = await fetch(`${API_BASE_URL}/api/events/${slug}`);
  if (!response.ok) throw new Error('Event not found');
  return response.json();
}

export async function fetchEventCapacity(eventId) {
  const response = await fetch(`${API_BASE_URL}/api/events/${eventId}/capacity`);
  if (!response.ok) throw new Error('Failed to fetch capacity');
  return response.json();
}

export async function createRSVP(eventId, rsvpData) {
  const response = await fetch(`${API_BASE_URL}/api/events/${eventId}/rsvp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(rsvpData)
  });
  
  const data = await response.json(); // Read once
  
  if (!response.ok) {
    throw new Error(data.detail || 'RSVP failed');
  }
  
  return data;
}

export async function joinWaitlist(eventId, waitlistData) {
  const response = await fetch(`${API_BASE_URL}/api/events/${eventId}/waitlist`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(waitlistData)
  });
  
  const data = await response.json(); // Read once
  
  if (!response.ok) {
    throw new Error(data.detail || 'Failed to join waitlist');
  }
  
  return data;
}

export function formatDate(dateString, timezone = 'America/New_York') {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timezone,
  }).format(date);
}

export function downloadCalendar(eventId, eventSlug) {
  const url = `${API_BASE_URL}/api/events/${eventId}/calendar`;
  const link = document.createElement('a');
  link.href = url;
  link.download = `${eventSlug}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
